import * as React from "react"
import { applyDefaultsAndStylesFromConfig, StandardAppStyling } from "./BasicMuiStyles"
import { FrontendApplication } from "./FrontendApplication"
import { loadFrontendConfig } from "@core-ts/Config"

// Picked up from the FrontendApplication class

export function implementFrontend(
    applicationName: string,
    baseStyle: Partial<StandardAppStyling>,
    render: (styles: StandardAppStyling) => Promise<React.ReactNode>,
): void {
    const application = new FrontendApplication(applicationName)

    application.runFrontendInstance = async () => {
        const finalStyle = applyDefaultsAndStylesFromConfig(baseStyle ?? {})
        return render(finalStyle)
    }

    application.startApplication(loadFrontendConfig())
}

export function insertIf<T, K>(condition: boolean, defaultReturnValue: K, element: T): T | K {
    return condition ? element : defaultReturnValue
}

